import { render } from "./addPermission.vue?vue&type=template&id=1f74afdc&scoped=true"
import script from "./addPermission.vue?vue&type=script&lang=js"
export * from "./addPermission.vue?vue&type=script&lang=js"

import "./addPermission.vue?vue&type=style&index=0&id=1f74afdc&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f74afdc"]])

export default __exports__